<template>
    <div class="animated fadeIn">

        <SearchForm
                ref="cardSearchForm"
                caption="Recherche"
                @onSubmit="search"
                @onReset="reset"
                :structure=" {
                    rows: [
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'start'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'end'
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    fields: [
                        {
                            id: 'start',
                            type: 'date',
                            label: Core.Definition.getDefinition('Début'),
                        },
                        {
                            id: 'end',
                            type: 'date',
                            label: Core.Definition.getDefinition('Fin'),
                        }
                    ]
                }">
        </SearchForm>

        <Request
                ref="request"
                :onRequestSuccess="requestSuccess"
                root="/report/event-popularity">
            <slot slot="body">
                <b-row v-if="dataWeekDayPie !== false && dataHourlyLine !== false">
                    <b-col lg="6">
                        <CardChartLine
                                :chart="{
                                     labels: dataHourlyLine.labels,
                                     sets:[
                                          {
                                            label: Core.Definition.getDefinition('Visites à l\'heure'),
                                            backgroundColor: 'rgba(102, 217, 255, .5)',
                                            borderColor: 'rgba(255,255,255,.5)',
                                            data: dataHourlyLine.data
                                          }
                                        ]
                                }">
                        </CardChartLine>
                    </b-col>
                    <b-col lg="6">
                        <CardChartPie
                                :chart="{
                                     labels: dataWeekDayPie.labels,
                                     sets:[
                                          {
                                           label: Core.Definition.getDefinition('Jour de la semaine'),
                                          backgroundColor: [
                                            'rgba(102, 217, 255)',
                                            'rgba(102, 140, 255)',
                                            'rgba(153, 102, 255)',
                                            'rgba(255, 102, 102)',
                                            'rgba(255, 140, 102)',
                                            'rgba(255, 179, 102)',
                                            'rgba(255, 190, 102)'
                                          ],
                                            data: dataWeekDayPie.data
                                          }
                                      ]
                                }">
                        </CardChartPie>
                    </b-col>
                </b-row>
            </slot>
        </Request>

    </div>
</template>

<script>
    import CardChartBar from '../../../../components/CardChartBar'
    import CardChartLine from '../../../../components/CardChartLine'
    import CardChartPie from '../../../../components/CardChartPie'
    import Request from '../../../../components/Request'
    import SearchForm from '../../../../components/SearchForm'
    export default {
        name: 'ReportEventPopularity',
        components: {
            CardChartBar,
            CardChartLine,
            CardChartPie,
            Request,
            SearchForm
        },
        props: {
        },
        watch: {
        },
        mounted() {
            this.reset()
        },
        data: function () {
            return {
                Core: window.Core,
                dataWeekDayPie: false,
                dataHourlyLine: false
            }
        },
        methods: {
            reset() {
                this.$refs.request.clearArgs()
                this.$refs.request.request()
            },
            search(form, fieldRefs, structure) {
                this.$refs.request.clearArgs()
                this.$refs.request.addArg('start', form.start, Core.Value.typeDate)
                this.$refs.request.addArg('end', form.end, Core.Value.typeDate)
                this.$refs.request.request()
            },
            requestSuccess(data) {
                if(data !== undefined && data.weekDayPie !== undefined) {
                    this.dataWeekDayPie = data.weekDayPie
                }
                if(data !== undefined && data.hourlyLine !== undefined) {
                    this.dataHourlyLine = data.hourlyLine
                }
            }
        }
    }
</script>
